import React from 'react';
import './MensajeValidacion.css';

const MensajeValidacion = ({ mensaje, onClose }) => {
  if (!mensaje || !mensaje.texto) return null;

  const getIcon = () => {
    switch (mensaje.tipo) {
      case 'error':
      case 'proyecto_incorrecto':
      case 'sin_stock':
      case 'cantidad_insuficiente':
        return '⚠️';
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return 'ℹ️';
    }
  };

  const getColor = () => {
    switch (mensaje.tipo) {
      case 'error':
      case 'proyecto_incorrecto':
      case 'sin_stock':
      case 'cantidad_insuficiente':
        return '#fee';
      case 'success':
        return '#efe';
      case 'warning':
        return '#ffc';
      case 'info':
        return '#def';
      default:
        return '#f5f5f5';
    }
  };

  const getBorderColor = () => {
    switch (mensaje.tipo) {
      case 'error':
      case 'proyecto_incorrecto':
      case 'sin_stock':
      case 'cantidad_insuficiente':
        return '#ef4444';
      case 'success':
        return '#10b981';
      case 'warning':
        return '#f59e0b';
      case 'info':
        return '#3b82f6';
      default:
        return '#94a3b8';
    }
  };

  return (
    <div 
      className="mensaje-validacion"
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 10000,
        backgroundColor: getColor(),
        border: `3px solid ${getBorderColor()}`,
        borderRadius: '12px',
        padding: '20px 25px',
        maxWidth: '500px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        animation: 'slideIn 0.3s ease-out'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'start', gap: '15px' }}>
        <div style={{ fontSize: '32px', flexShrink: 0 }}>
          {getIcon()}
        </div>
        
        <div style={{ flex: 1 }}>
          {/* Título principal */}
          <div style={{ 
            fontWeight: 'bold', 
            fontSize: '16px', 
            color: '#1f2937',
            marginBottom: '8px'
          }}>
            {mensaje.mensaje || mensaje.texto}
          </div>

          {/* Detalle */}
          {mensaje.detalle && (
            <div style={{ 
              fontSize: '14px', 
              color: '#4b5563',
              marginBottom: '12px',
              lineHeight: '1.5'
            }}>
              {mensaje.detalle}
            </div>
          )}

          {/* Información adicional */}
          {mensaje.material && (
            <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '8px' }}>
              <strong>Material:</strong> {mensaje.material}
            </div>
          )}
          
          {mensaje.almacen && (
            <div style={{ fontSize: '13px', color: '#6b7280' }}>
              <strong>Almacén:</strong> {mensaje.almacen}
            </div>
          )}

          {mensaje.proyecto_actual && (
            <div style={{ fontSize: '13px', color: '#6b7280' }}>
              <strong>Proyecto asignado:</strong> {mensaje.proyecto_actual}
            </div>
          )}

          {mensaje.cantidad_disponible !== undefined && (
            <div style={{ fontSize: '13px', color: '#6b7280' }}>
              <strong>Stock disponible:</strong> {mensaje.cantidad_disponible} unidades
            </div>
          )}

          {mensaje.cantidad_solicitada && (
            <div style={{ fontSize: '13px', color: '#6b7280' }}>
              <strong>Cantidad solicitada:</strong> {mensaje.cantidad_solicitada}
            </div>
          )}

          {mensaje.faltante && (
            <div style={{ fontSize: '13px', color: '#ef4444' }}>
              <strong>Faltante:</strong> {mensaje.faltante} unidades
            </div>
          )}

          {/* Acción requerida */}
          {mensaje.accion_requerida && (
            <div style={{ 
              marginTop: '12px',
              padding: '10px',
              backgroundColor: 'rgba(0,0,0,0.05)',
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: '500',
              color: '#1f2937'
            }}>
              💡 {mensaje.accion_requerida}
            </div>
          )}
        </div>

        {/* Botón cerrar */}
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#9ca3af',
            padding: '0',
            width: '30px',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
          onMouseOver={(e) => e.target.style.color = '#4b5563'}
          onMouseOut={(e) => e.target.style.color = '#9ca3af'}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default MensajeValidacion;